import { Expose, Transform } from "class-transformer";
import { toCents } from "@/utils/numberUtils";

function toRequiredCents(value: number): number {
  return toCents(Number(value));
}

export class CreatePointPriceConfigurationDto {
  @Expose()
  points: number;

  @Expose()
  @Transform(({ value }) => toRequiredCents(value))
  technicianPriceCents: number;

  @Expose()
  @Transform(({ value }) => toRequiredCents(value))
  driverPriceCents: number;

  @Expose()
  @Transform(({ value }) => toRequiredCents(value))
  assistantPriceCents: number;
}
